import CardSlider from './CardSlider.jsx';

export default CardSlider;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/index.js